export default "__VITE_ASSET__DnGSy88O__"